import { AppRoute } from 'constants/AppRoute';
import { TestLocators } from 'constants/Locators';

import { MUI, ThemeMode } from 'ci-esi-web-shared';
import { ReactElement } from 'react';

import { colors } from 'styles/theme/colors';

import { HeaderLandingPage } from '../HeaderLandingPage';
import { HEADER_HEIGHT } from './constants';

export interface MainLayoutProps {
  children: ReactElement;
  testId?: TestLocators;
  path?: string;
}

export function MainLayout({ children, testId, path }: MainLayoutProps) {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;

  const overflowYHidden = !!path?.includes(AppRoute.ECONOMICS);

  return (
    <>
      <HeaderLandingPage />
      <main
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          overflowY: overflowYHidden ? 'hidden' : 'auto',
          backgroundColor: isDarkMode ? colors.grey85 : colors.lightWhite,
        }}
      >
        <MUI.Container
          maxWidth={false}
          data-testid={testId}
          disableGutters
          sx={{
            overflow: 'hidden',
            backgroundColor: 'transparent',
          }}
        >
          {children}
        </MUI.Container>
      </main>
    </>
  );
}
